class SayeGallery extends HTMLElement {
  connectedCallback() {
    this.mediaEls = Array.from(this.querySelectorAll('.saye-buy__media-sources [data-media-id]'));
    this.thumbEls = Array.from(this.querySelectorAll('[data-thumb]'));
    this.mainWrap = this.querySelector('.saye-buy__shot-main-wrap');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.currentIndex = 0;

    if (this.mediaEls.length <= 1) {
      if (this.prevBtn) this.prevBtn.hidden = true;
      if (this.nextBtn) this.nextBtn.hidden = true;
      return;
    }

    this.thumbEls.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this._goToIndex(index));
    });

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._goToIndex(this.currentIndex - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._goToIndex(this.currentIndex + 1));

    this._setupSwipe();
  }

  _goToIndex(index) {
    const count = this.mediaEls.length;
    this.currentIndex = (index + count) % count;

    const target = this.mediaEls[this.currentIndex];
    if (target) this._showMedia(target);

    this.thumbEls.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === this.currentIndex);
    });
  }

  _showMedia(target) {
    const main = this.querySelector('[data-main-media]');
    if (!main) return;
    main.innerHTML = target.innerHTML;
  }

  _setupSwipe() {
    if (!this.mainWrap) return;

    let startX = 0;
    let deltaX = 0;

    this.mainWrap.addEventListener(
      'touchstart',
      (event) => {
        startX = event.touches[0].clientX;
        deltaX = 0;
      },
      { passive: true }
    );

    this.mainWrap.addEventListener(
      'touchmove',
      (event) => {
        deltaX = event.touches[0].clientX - startX;
      },
      { passive: true }
    );

    this.mainWrap.addEventListener('touchend', () => {
      if (Math.abs(deltaX) > 40) {
        this._goToIndex(this.currentIndex + (deltaX < 0 ? 1 : -1));
      }
    });
  }
}

customElements.define('saye-gallery', SayeGallery);
